import * as api from '../apiCallerProxy';
import { campaignsApiFactory } from './campaignsApiFactory';

export * from './hooks';
export default campaignsApiFactory(api);
